import React, { useMemo, useState } from 'react'
import '../scss/button.scss';
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as CheckIcon } from '../images/check.svg'
import { ReactComponent as CheckIconChk } from '../images/check-icon-green.svg'
import { useDispatch, useSelector } from 'react-redux';
import CenteredPopup from '../components/popups/CenteredPopup';
import PageHeader from '../components/PageHeader';
import { useSendVerificationOTPMutation, useVerifySentOTPMutation, useVerifyUANMutation } from '../lib/services/employmentApi';
import { closeErrorModal, openErrorModal, setEmailAddress, setEmailError, setEmailSent, setEmailSuccess, setOTP, setOTPError, setPageError, setUAN, setUANError, setVerificationType } from '../lib/features/employmentSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSkipPageMutation } from '../lib/services/businessApi';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";


function EmploymentDetails() {
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const { pageerror, verificationType, emailAddress, otp, uan, uanerror, isErrorModalOpen, emailerror, emailsuccess, emailsent } = useSelector((state) => state.employment);
    const [sendVerificationOTP, { isLoading: otpSending }] = useSendVerificationOTPMutation()
    const [verifySentOTP, { isLoading: otpVerifing }] = useVerifySentOTPMutation()
    const [verifyUAN, { isLoading: uanVerifing }] = useVerifyUANMutation()
    const [skipPage, { isLoading: skippingPage }] = useSkipPageMutation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const [timer, setTimer] = useState(0);
    const [otpSent, setOtpSent] = useState(true);
    const [filled, setFilled] = useState(false);
    const [tapClick] = useTapClickMutation()
    const modalButtons = [
        { label: 'Close', onClick: () => dispatch(closeErrorModal()) }
    ]
    const sendOtp = async () => {
        const emailValidationRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailAddress) {
            dispatch(setEmailError('Please provide email.'));
            return;
        }
        if (!emailValidationRegex.test(emailAddress)) {
            dispatch(setEmailError('Invalid email address. Please enter a valid email.'));
            return;
        }
        let jwt_token
        if (jwt) {
            jwt_token = jwt
            localStorage.setItem('jwt', jwt)
        } else {
            jwt_token = localStorage.getItem('jwt')
        }
        const scrt = secret ? secret : localStorage.getItem('secret')
        const result = await sendVerificationOTP({ email: emailAddress, jwt_token, scrt })
        if (result && result.data && result.data.status === 'error' && result.data.message === 'Login expired! Please re-login.') {
            localStorage.removeItem('jwt');
            localStorage.removeItem('lastVisitedPage');
            const phone = localStorage.getItem('phone')
            localStorage.clear()
            phone ? navigate(`/?phone=${phone}`) : navigate('/');
            
        }
        else if (result.data && result.data.http_code === 201) {
            dispatch(setPageError(result.data.message))
            dispatch(openErrorModal())
        } else if (result && result.data && result.data.status === 'error') {
            dispatch(setPageError(result.data.message))
            dispatch(openErrorModal())
        } else if (result.error) {
            dispatch(setPageError('Please check your internet or try again later.'))
            dispatch(openErrorModal())
        } else if (result && result.data && (result.data.status === 'success' || result.data.status === true)) {
            dispatch(setEmailSuccess(result.data.message))
            dispatch(setEmailSent(true))
            dispatch(setOTP(''));
            dispatch(setPageError(''))
            dispatch(setVerificationType('work email'))
            setTimer(30);
            setOtpSent(true)
            const countdown = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(countdown);
                        setOtpSent(false)
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            setTimeout(() => {
                dispatch(setEmailSuccess(''))
            }, 2500);
        }
    }
    const handleVerifyOtp = async () => {
        if (!otp) {
            dispatch(setOTPError('Please provide otp.'));
            return;
        }
        if (otp.length !== 4) {
            dispatch(setOTPError('OTP must be 4 digits.'))
            return
        }
        if (isNaN(otp)) {
            dispatch(setOTPError('OTP must be numeric.'));
            return;
        }
        let jwt_token
        if (jwt) {
            jwt_token = jwt
            localStorage.setItem('jwt', jwt)
        } else {
            jwt_token = localStorage.getItem('jwt')
        }
        const scrt = secret ? secret : localStorage.getItem('secret')
        const result = await verifySentOTP({ email: emailAddress, otp, jwt_token, scrt })
        if (result && result.data && result.data.status === 'error' && result.data.message === 'Login expired! Please re-login.') {
            localStorage.removeItem('jwt');
            localStorage.removeItem('lastVisitedPage');
            const phone = localStorage.getItem('phone')
            localStorage.clear()
            phone ? navigate(`/?phone=${phone}`) : navigate('/');
            
        }
        else if (result.data && result.data.http_code === 201) {
            dispatch(setPageError(result.data.message))
            dispatch(openErrorModal())
        } else if (result && result.data && result.data.status === 'error') {
            dispatch(setPageError(result.data.message))
            dispatch(openErrorModal())
        } else if (result.error) {
            dispatch(setPageError('Please check your internet or try again later.'))
            dispatch(openErrorModal())
        } else if (result && result.data && (result.data.status === 'success' || result.data.status === true)) {
            if (result.data.redirect_url) {
                const event_name = 'Web_email_verified'
                const event_property = { Source: window.localStorage.getItem('utm_source'), segment: result.data.customer_segmentation }
                await pushCleverTapEvent({ event_name, event_property })
                window.location.href = result.data.redirect_url
            }
        }
    }
    const handleVerifyUAN = async () => {
        if (!uan) {
            dispatch(setUANError('Please provide uan number.'));
            return;
        }
        if (uan.length !== 14 || !/^\d{12}$/.test(uan.replace(/\s+/g, ''))) {
            dispatch(setUANError('UAN must be 12 digits.'))
            return
        }
        if (isNaN(uan.split(' ').join(''))) {
            dispatch(setUANError('UAN must be numeric.'));
            return;
        }
        let jwt_token
        if (jwt) {
            jwt_token = jwt
            localStorage.setItem('jwt', jwt)
        } else {
            jwt_token = localStorage.getItem('jwt')
        }
        const scrt = secret ? secret : localStorage.getItem('secret')
        const result = await verifyUAN({ uan: uan.split(' ').join(''), jwt_token, scrt })
        if (result && result.data && result.data.status === 'error' && result.data.message === 'Login expired! Please re-login.') {
            localStorage.removeItem('jwt');
            localStorage.removeItem('lastVisitedPage');
            const phone = localStorage.getItem('phone')
            localStorage.clear()
            phone ? navigate(`/?phone=${phone}`) : navigate('/');
            
        }
        else if (result.data && (result.data.http_code === 201 || result.data.error_code === "Unauthorized")) {
            dispatch(setPageError(result.data.message))
            dispatch(openErrorModal())
        } else if (result && result.data && result.data.status === 'error') {
            dispatch(setPageError(result.data.message))
            dispatch(openErrorModal())
        } else if (result.error) {
            dispatch(setPageError('Please check your internet or try again later.'))
            dispatch(openErrorModal())
        } else if (result && result.data && (result.data.status === 'success' || result.data.status === true)) {
            if (result.data.redirect_url) {
                pushCleverTapEvent({
                    event_name: 'web_document_submitted',
                    event_property: {
                        Source: window.localStorage.getItem('utm_source'),
                        segment: localStorage.getItem('customerSegment'),
                        "document type": "n/a",
                        occupation: "salaried"
                    }
                })
                window.location.href = result.data.redirect_url
            }
        }
    }

    const handleSkip = async () => {
        try {
            let jwt_token
            if (jwt) {
                jwt_token = jwt
                localStorage.setItem('jwt', jwt)
            } else {
                jwt_token = localStorage.getItem('jwt')
            }
            const scrt = secret ? secret : localStorage.getItem('secret')
            const result = await skipPage({ jwt_token, scrt, page: 'employment-details' })
            if ((result.data && (result.data.status === 'error' || result.data.status === false)) || (result && result.status === 'error')) {
                dispatch(setPageError(result.data.message || 'Some error occured. Please try again.'))
                dispatch(openErrorModal())
                if (result.data.message === 'Login expired! Please re-login.') {
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    
                }
            } else if (result.data && result.data.http_code === 201) {
                if (result.data.message === 'Login expired! Please re-login.') {
                    dispatch(setPageError(result.data.message))
                    dispatch(openErrorModal())
                    localStorage.removeItem('jwt');
                    localStorage.removeItem('lastVisitedPage');
                    const phone = localStorage.getItem('phone')
                    localStorage.clear()
                    phone ? navigate(`/?phone=${phone}`) : navigate('/');
                    
                } else {
                    dispatch(setPageError(result.data.message))
                    dispatch(openErrorModal())
                }
            } else if (result.error) {
                dispatch(setPageError('Please check your internet or try again later.'))
                dispatch(openErrorModal())
            } else {
                if (result && result.data && result.data.redirect_url) {
                    pushCleverTapEvent({
                        event_name: 'Button Clicked',
                        event_property: {
                            Source: window.localStorage.getItem('utm_source'),
                            segment: localStorage.getItem('customerSegment'),
                            CTA: "Skip",
                            pagename: "Employment Details"
                        }
                    })
                    window.location.href = result.data.redirect_url
                }
            }
        } catch (error) {
            dispatch(setPageError('Something went wrong. Please try again later.'));
        }
    }

    return (
        <div className={`external-wrapper employment-details`}>
            <CenteredPopup
                isOpen={isErrorModalOpen}
                buttons={modalButtons}
                onClose={() => dispatch(closeErrorModal())} icon={<WarningIcon />}>
                <p>{pageerror}</p>
            </CenteredPopup>
            <div className='page-content'>
                <PageHeader />
                <div className='page-heading'>
                    <h2 className='page-title'>Verify your employment details</h2>
                </div>
                {/*<div className="radio-wrapper">
                    <div className='radios'>
                        <div className='radio'>
                            <input
                                type="radio"
                                name="verificationType"
                                value="true"
                                id="workemail"
                                checked={verificationType === 'work email'}
                                onChange={() => dispatch(setVerificationType('work email'))}
                            />{' '}
                            <label htmlFor='workemail'>Work email</label>
                        </div>
                        <div className='radio'>
                            <input
                                type="radio"
                                name="verificationType"
                                id="uan"
                                value="false"
                                checked={verificationType === 'uan'}
                                onChange={() => dispatch(setVerificationType('uan'))}
                                className="ms-3"
                            />{' '}
                            <label htmlFor='uan'>UAN</label>
                        </div>
                    </div>
                </div>*/}
                {/*verificationType === 'work email' ? '' : '' */}
                <div className="input-wrapper otp-email">
                    <input
                        type="text"
                        autoComplete='off'
                        name="emailAddress"
                        placeholder=" "
                        value={emailAddress}
                        onChange={(e) => {
                            const value = e.target.value;
                            const formattedValue = value.replace(/[^A-Za-z0-9@._-]/g, "");
                            dispatch(setEmailAddress(formattedValue));
                            setTimer(0)
                            dispatch(setEmailSent(false))
                            dispatch(setEmailSuccess(''))
                            dispatch(setEmailError(''))
                        }}
                        style={{ paddingRight: emailsent ? '20px' : '' }}
                        className={`form-control`}
                    />
                    <label>Email ID Address</label>
                    {!emailsent ? <button className={`btn btn-primary ${!emailAddress || otpSending || timer ? 'disabled' : null}`} onClick={sendOtp}>Send OTP</button> : null}
                </div>
                {emailerror ? <p className='error ps-0'>{emailerror}</p> : null}
                {emailsuccess ? <p className='success ps-0'><CheckIcon /> OTP sent successfully</p> : null}
                {emailsent && verificationType === 'work email' ? <><div className="input-wrapper otp-email">
                    <input
                        type="text"
                        autoComplete='off'
                        name="otp"
                        placeholder=" "
                        maxLength={4}
                        inputMode="numeric"
                        value={otp}
                        onChange={(e) => {
                            const value = e.target.value;
                            const formattedValue = value.replace(/[^0-9]/g, "").slice(0, 4);
                            dispatch(setOTP(formattedValue));
                        }}
                        className={`form-control otp-input`}
                    />
                    <label>Enter OTP</label>
                    <button className={`btn btn-primary ${otpVerifing || !otp || (otp && otp.length !== 4) ? 'disabled' : ''}`} onClick={handleVerifyOtp}>Verify OTP</button>
                </div>
                    <p>OTP has been sent to {emailAddress}</p>
                    <p className='resend'>{timer ? <span className='time'>Resend OTP in {timer}s</span> : <span onClick={sendOtp} className={`link ${otpSent ? 'disabled' : ''}`} style={{ fontWeight: 500 }}>Resend OTP</span>} </p></> : null}
                {verificationType === 'uan' ? <div className="input-wrapper otp-email uan-field">
                    <input
                        type="text"
                        autoComplete='off'
                        name="uan"
                        maxLength={14}
                        placeholder=" "
                        value={uan}
                        onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            const formattedValue = value
                                .match(/.{1,4}/g)
                                ?.join(" ")
                                .slice(0, 14);
                            dispatch(setUAN(formattedValue || ""));
                            setFilled(formattedValue?.replace(/\s/g, "").length === 12);
                        }}
                        className={`form-control`}
                    />
                    <label>Enter 12 Digit UAN number</label>
                    {filled && <span className='completed'><CheckIconChk /></span>}
                </div> : null}
                {uanerror ? <p className='error ps-0'>{uanerror}</p> : null}
                <div className={`skip-link link ${skippingPage ? 'disabled' : ''}`} onClick={handleSkip}>Skip</div>
            </div>
            <div className='bottom-footer ps-0 pe-0'>
                <p className='powered-by'>Powered by <StarfinLogo /></p>
                {verificationType === 'uan' && <button type="button" className={`btn btn-primary ${uanVerifing ? 'disabled' : ''}`} onClick={handleVerifyUAN}>Continue</button>}
            </div>
        </div>
    )
}

export default EmploymentDetails
